
export enum WMSRecvStep {
  ScanBatch,
  ScanLocation,
  ScanSku,
};

export enum WHTActionType {
  SetCurrentWMSBatch,
  SetLockScreen,
  SetRecvLocation,
  SetSelectedWarehouse,
  SetWMSRecvStep,
};

type WHTAction = {
  type: WHTActionType,
  params: any,
};

type WHTState = {
  recvLocation: StringKAnyVPair;
  currentWMSBatch: StringKAnyVPair;
  lockScreen: boolean;
  selectedWarehouse: StringKAnyVPair;
  wmsRecvStep: WMSRecvStep;
};

export const initialState = (state: StringKAnyVPair) => ({
  currentWMSBatch: {},
  lockScreen: false,
  recvLocation: {},
  selectedWarehouse: {},
  wmsRecvStep: WMSRecvStep.ScanBatch,
  ...state,
});

export const reducer = (state: WHTState, action: WHTAction) => {
  switch (action.type) {
    case WHTActionType.SetCurrentWMSBatch:
      return { ...state, currentWMSBatch: { ...action.params } };

    case WHTActionType.SetLockScreen:
      return { ...state, lockScreen: action.params };

    case WHTActionType.SetRecvLocation:
      return { ...state, recvLocation: { ...action.params } };

    case WHTActionType.SetSelectedWarehouse:
      return { ...state, selectedWarehouse: { ...action.params } };

    case WHTActionType.SetWMSRecvStep:
      return { ...state, wmsRecvStep: action.params };

    default:
      return state;
  }
};
